import React from 'react';
import { styled } from '@mui/material/styles';
import { LinearProgress, LinearProgressProps } from '@mui/material';
import { StageStatus } from '../types';

const StyledProgress = styled(LinearProgress)<{ status: StageStatus }>(({ theme, status }) => ({
  height: 4,
  borderRadius: 2,
  backgroundColor: theme.palette.grey[200],
  '.MuiLinearProgress-bar': {
    borderRadius: 2,
    backgroundColor: 
      status === 'error' ? theme.palette.error.main :
      status === 'error_continuing' ? theme.palette.warning.main :
      status === 'completed' ? theme.palette.success.main :
      theme.palette.primary.main,
    transition: 'transform 0.3s ease',
  },
}));

interface ProgressBarProps extends Omit<LinearProgressProps, 'value'> {
  progress: number;
  status: StageStatus;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ progress, status, ...props }) => {
  return (
    <StyledProgress
      variant="determinate"
      value={progress}
      status={status}
      {...props}
    />
  );
}; 